/** 
 * @props handleDrop: callback function to handle the onDrop event
 * @props dropTargetIdentifier: unique identifier for the drop target
*/

import React, { useState } from 'react';
import styles from './DropTarget.styles';

export default function DropTarget({handleDropCb, dropTargetIdentifier, children, customStyles, hoverColor = "#83CFA4"}) {

	const [isHovered, setIsHovered] = useState(false);

	const handleDragOver = (e) => {
		e.preventDefault();
		setIsHovered(true);
	};

	const handleDragLeave = () => {
		setIsHovered(false);
	};

	const handleDrop = (e) => {
		e.preventDefault();
		setIsHovered(false);
		handleDropCb(e, dropTargetIdentifier);
	};
	
	const dropTargetStyle = {
		...customStyles,
	};
	
	return (
		<div
			style={{...dropTargetStyle, ...(isHovered ? {backgroundColor: hoverColor} : {})}}
			onDragOver={handleDragOver}
			onDragLeave={handleDragLeave}
			onDrop={handleDrop}
		>
            {children}
		</div>
	);
};
